import { ActionTree } from 'vuex';
import { AxiosResponse } from 'axios';

import HttpService from '@/plugins/http-service';
import IRootState from '@/store/types/IRootState';

import IServicesState from './types/IServicesState';
import IServiceMeta from './types/IServiceMeta';
import IServiceHeader from './types/IServieHeader';
import IService from './types/IService';

const actions: ActionTree<IServicesState, IRootState> = {
  async load(context) {
    try {
      const { data: {
        meta,
        header,
        services,
      } }: AxiosResponse<{
        meta: IServiceMeta,
        header: IServiceHeader,
        services: IService[],
      }> = await HttpService.get('page/services.json');

      context.commit('setMeta', meta);
      context.commit('setHeader', header);
      context.commit('setServices', services);

      return { meta, header, services };
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default actions;
